import { type RouteRecordRaw } from 'vue-router'

export const brandKitRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/BrandKitView.vue'),
    meta: {
      roles: ['pb:super'],
      title: 'brand-kit',
    },
    name: 'brand.brand-kit',
    path: 'brand-kit',
  },
]
